/** localStorage key for new-entry draft autosave (must match CustomerEntryFormTab). */
export const CE_DRAFT_KEY = "ce_entry_draft_v1";
